import { Components } from 'react-markdown'

import styles from './markdownComponents.styl'

export const MarkdownComponents: Components = {
  a: (props) => <a className={styles.link} target='_blank' rel='noopener noreferrer' {...props} />,
}
